import { isFlashtalkingCreative } from 'common/js/format-helper';
import { FormatContext, ILoadingStrategy } from '../loading-strategy-factory';

export class FlashtalkingLoadingStrategy implements ILoadingStrategy {
  isRunnable(formatContext: any): boolean {
    return isFlashtalkingCreative(formatContext.config);
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    formatContext.config = {
      ...formatContext.config,
      injectOnViewable: true,
      redirectType: formatContext.config.redirectType || 'flashtalking'
    };

    return formatContext;
  }

  onAfterRender(formatContext: FormatContext): void {}

  onBeforeRender(formatContext: FormatContext): void {}

  onResize(formatContext: FormatContext): void {}
}
